module.exports = __webpack_public_path__ + "img/red-eight-pointed-alert-flower.b1278802.svg";